"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_enum_1 = require("../enum/environment.enum");
const environment_1 = require("../../constants/environment");
const payment_enum_1 = require("../enum/payment.enum");
const user_service_1 = require("../services/user.service");
class PaymentService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key, paymentGatewayEnv) {
        this.RESOURCE = 'payments';
        /**
         * Obtiene la configuración de los métodos de pago globales.
         * @returns {Array} PaymentMethod
         */
        this.getGlobalPaymentMethods = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/global-payment-methods`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtiene la configuración de todos los métodos de pago, incluyendo los globales y los del usuario especificado.
         * @param personId {number} id de la persona
         * @returns {Array} PaymentMethod
         */
        this.getPaymentMethods = async (personId) => {
            const globalPaymentMethods = await this.getGlobalPaymentMethods();
            const userPaymentMethods = [];
            // Verificar si existe el método de pago por tarjeta en los métodos de pago globales
            const cardPaymentMethodExists = globalPaymentMethods.some(method => method.payment_method_id === payment_enum_1.PAYMENT_METHODS.CARD);
            // Obtener los métodos de pago Conekta de la persona
            if (cardPaymentMethodExists && personId) {
                const customerCards = await this.userServiceSDK.conektaGetCustomerCard(personId);
                if (customerCards.length > 0) {
                    customerCards.forEach((customerCardGroup) => {
                        const groupedUserMethods = customerCardGroup === null || customerCardGroup === void 0 ? void 0 : customerCardGroup.reduce((acc, userMethod) => {
                            var _a, _b;
                            if (!acc[userMethod.last4]) {
                                acc[userMethod.last4] = {
                                    payment_type_id: payment_enum_1.PAYMENT_TYPES.USER,
                                    payment_gateway_id: payment_enum_1.PAYMENT_GATEWAYS.CONEKTA,
                                    payment_method_id: payment_enum_1.PAYMENT_METHODS.CARD,
                                    payment_gateway_method_id: 1,
                                    description: `Tarjeta con terminación ****${userMethod.last4}`,
                                    sort_order: 0,
                                    metadata: {
                                        bin: userMethod.bin,
                                        last4: userMethod.last4,
                                        type: userMethod.type,
                                        card_type: userMethod.card_type,
                                        exp_month: userMethod.exp_month,
                                        exp_year: userMethod.exp_year,
                                        brand: userMethod.brand,
                                        name: userMethod.name,
                                        country: userMethod.country_code,
                                    },
                                    instances: [],
                                    // msiOptions: [3, 6, 12]
                                };
                            }
                            (_b = (_a = acc[userMethod.last4]) === null || _a === void 0 ? void 0 : _a.instances) === null || _b === void 0 ? void 0 : _b.push({
                                ou: userMethod.ou,
                                id: userMethod.id
                            });
                            return acc;
                        }, {});
                        Object.values(groupedUserMethods).forEach((groupedUserMethod) => {
                            var _a;
                            return userPaymentMethods.push(Object.assign({ unique_id: `saved_method_${(_a = groupedUserMethod === null || groupedUserMethod === void 0 ? void 0 : groupedUserMethod.metadata) === null || _a === void 0 ? void 0 : _a.last4}` }, groupedUserMethod));
                        });
                    });
                }
            }
            return [...userPaymentMethods, ...globalPaymentMethods];
        };
        this.ENV = ENV;
        this.KEY = key;
        this.PAYMENT_GATEWAY_ENV = paymentGatewayEnv;
        this.userServiceSDK = new user_service_1.UserService(this.ENV, this.KEY, this.PAYMENT_GATEWAY_ENV);
    }
}
exports.PaymentService = PaymentService;
